const ACCOMMODATION = 'accommodation';
const DAILY_ALLOWANCE = 'daily-allowance';
const INSTALLATION = 'installation';
const LIFTERS = 'lifters';

export { ACCOMMODATION, DAILY_ALLOWANCE, INSTALLATION, LIFTERS };
